<template>
	<div class="container">
		<el-container>
			<el-header class="header">
				<headers />
			</el-header>
			<el-container>
				<slider />
				<el-main>
					<div class="main_box">
						<div class="main_main">
							<!-- Page Header -->
							<div class="page_header">My Training</div>
							<!-- Page Header -->
				
							<div class="page_main">
								<div class="training-page">
				
									<div class="user-block">
										<div class="label">User</div>
										<div>{{ userName }}</div>
									</div>
				
									<!-- Incomplete Training -->
									<div class="file-panel">
										<div class="panel-header">
											<div class="panel-title">Incomplete Training</div>
											<div class="panel-actions">
												<el-input
													v-model="unfinishedKeyword"
													placeholder="Search"
													clearable
													class="search-input">
													<i slot="prefix" class="el-input__icon el-icon-search"></i>
												</el-input>
											</div>
										</div>
				
										<el-table
											:data="unfinishedTableData"
											border
											class="file-table"
											header-cell-class-name="table-header-cell"
											empty-text="No incomplete training records found">
				
											<el-table-column label="Action" width="110" fixed="left">
												<template slot-scope="scope">
													<el-button
														type="primary"
														size="mini"
														@click="handleComplete(scope.row)">
														Complete Training
													</el-button>
												</template>
											</el-table-column>
				
											<el-table-column label="Item ID" min-width="200" sortable>
												<template slot-scope="scope">
													{{ scope.row.item_name }}
												</template>
											</el-table-column>
				
											<el-table-column
												prop="type"
												label="Training Item Type"
												min-width="160"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.leixing_name }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Training Due Date"
												min-width="180"
												sortable>
												<template slot-scope="scope">
													{{ initTime(scope.row.end_time) }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Assigned User"
												min-width="150"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.is_assigned == 1 ? "Yes" : "No" }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Certification Required?"
												min-width="200"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.is_certification == 1 ? "Yes" : "No" }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Purpose"
												min-width="120"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.purpose == 1 ? "Initial Training" : "Retraining" }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Supervisor"
												min-width="150"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.monitor_username || "N/A" }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Action"
												width="80"
												align="center"
												fixed="right">
												<template slot-scope="scope">
													<el-link
														type="primary"
														size="mini"
														@click="handleInfo(scope.row)">
														Details
													</el-link>
												</template>
											</el-table-column>
				
										</el-table>
									</div>
				
									<!-- Incomplete Certification -->
									<div class="file-panel">
										<div class="panel-header">
											<div class="panel-title">Incomplete Certification</div>
											<div class="panel-actions">
												<el-input
													v-model="certificationKeyword"
													placeholder="Search"
													clearable
													class="search-input">
													<i slot="prefix" class="el-input__icon el-icon-search"></i>
												</el-input>
											</div>
										</div>
				
										<el-table
											ref="cerTable"
											:data="certificationTableData"
											border
											class="file-table"
											header-cell-class-name="table-header-cell"
											empty-text="No incomplete certification records found">
				
											<el-table-column
												label="Item ID"
												min-width="200"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.item_name }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Purpose"
												min-width="120"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.purpose == 1 ? "Initial Training" : "Retraining" }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Certification Due Date"
												min-width="180"
												sortable>
												<template slot-scope="scope">
													{{ initTime(scope.row.certification_end_time) }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Certification Method"
												min-width="200"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.certification_method || "" }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Certification Evidence"
												min-width="300">
												<template slot-scope="scope">
													<ul class="file-list-inline">
														<li
															v-for="(file, index) in scope.row.files"
															:key="index">
															<a :href="file.url" target="_blank">
																{{ file.name }}
															</a>
														</li>
													</ul>
												</template>
											</el-table-column>
				
											<el-table-column
												label="Supervisor"
												min-width="150"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.monitor_username || "N/A" }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Action"
												width="80"
												align="center"
												fixed="right">
												<template slot-scope="scope">
													<el-link
														type="primary"
														size="mini"
														@click="handleInfo(scope.row)">
														Details
													</el-link>
												</template>
											</el-table-column>
				
										</el-table>
									</div>
				
									<!-- Training Requirements -->
									<div class="file-panel">
										<div class="panel-header">
											<div class="panel-title">Training Requirements</div>
											<div class="panel-actions">
												<el-input
													v-model="requirementKeyword"
													placeholder="Search"
													clearable
													class="search-input">
													<i slot="prefix" class="el-input__icon el-icon-search"></i>
												</el-input>
											</div>
										</div>
				
										<el-table
											:data="requirementTableData"
											border
											class="file-table"
											header-cell-class-name="table-header-cell"
											empty-text="No training requirements found">
				
											<el-table-column
												label="Item ID"
												min-width="260"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.item_name }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Training Item Type"
												min-width="320"
												sortable>
												<template slot-scope="scope">
													{{ scope.row.leixing_name }}
												</template>
											</el-table-column>
				
											<el-table-column
												label="Status"
												min-width="120"
												sortable>
												<template slot-scope="scope">
													<div v-if="scope.row.superviseinfo">
														<div v-if="scope.row.superviseinfo.status == 1">
															In Progress
														</div>
														<div v-if="scope.row.superviseinfo.status == 2">
															Completed
														</div>
														<div v-if="scope.row.superviseinfo.status == 9">
															Withdrawn
														</div>
													</div>
													<div v-else>N/A</div>
												</template>
											</el-table-column>
				
										</el-table>
									</div>
				
								</div>
							</div>
						</div>
					</div>
				</el-main>
			</el-container>
		</el-container>
		<!--loading-->
		<transition name="fade">
			<div class="loading" v-show="isLoading">
				<van-loading />
			</div>
		</transition>
		<!--loading-->
	</div>
</template>

<script>
	import {
		trainUsersDetail
	} from "@/api/trainManage/myTrain/index";
	import headers from "@/component/header.vue";
	import slider from "@/component/slider.vue";
	import moment from "moment";
	export default {
		components: {
			headers,
			slider,
		},
		data() {
			return {
				isLoading: true,
				unfinishedKeyword: "",
				requirementKeyword: "",
				certificationKeyword: "",
				unfinishedSource: [],
				requirementSource: [],
				certificationSource: [],
				userName: "",
			};
		},
		mounted() {
			let that = this;
			that.isLoading = false;
			that.getTableData();
		},
		computed: {
			unfinishedTableData() {
				return this.filterTableData(
					this.unfinishedSource,
					this.unfinishedKeyword
				);
			},
			requirementTableData() {
				return this.filterTableData(
					this.requirementSource,
					this.requirementKeyword
				);
			},
			certificationTableData() {
				return this.filterTableData(
					this.certificationSource,
					this.certificationKeyword
				);
			},
		},
		methods: {
			//时间戳转换
			initTime(value) {
				if (value) {
					return moment(value * 1000).format("YYYY-MM-DD");
				}
			},
			getTableData() {
				let that = this;
				trainUsersDetail().then((res) => {
					if (res.code == 200) {
						that.userName = localStorage.getItem("userAccount") || "/";
						that.unfinishedSource = res.data.train_list;
						that.certificationSource = res.data.cert_list;
						that.requirementSource = res.data.record_list;
					}
				});
			},
			filterTableData(source, keyword) {
				if (!keyword || !keyword.trim()) return source;
				const lowerKeyword = keyword.toLowerCase().trim();
				return source.filter((item) => {
					const text = this.flattenValues(item).toLowerCase();
					return text.includes(lowerKeyword);
				});
			},
			flattenValues(data) {
				if (data === null || data === undefined) return "";
				if (Array.isArray(data)) {
					return data.map((item) => this.flattenValues(item)).join(" ");
				}
				if (typeof data === "object") {
					return Object.values(data)
						.map((val) => this.flattenValues(val))
						.join(" ");
				}
				return String(data);
			},
			//完成培训
			handleComplete(row) {
				let that = this;
				that.$router.push({
					path: "/TrainControl/train-signature",
					query: {
						oid: row.flow_id
					},
				});
			},
			handleInfo(row) {
				let that = this;
				const routeData = that.$router.resolve({
					path: '/TrainControl/record-detail',
					query: {
						id: row.id
					}
				});
				window.open(routeData.href, "_blank");
			},
			goUrl(url) {
				this.$router.push(url);
			},
		},
	};
</script>

<style lang="less" scoped>
	//主要内容
	.main_main {
		.page_main {
			padding: 18px 20px;

			.btn_el {
				margin: 10px 0 20px 0;

				.tips {
					padding: 6px 8px;
					background-color: #ffb1001a;
					border-radius: 6px;
					font-size: 16px;
					font-weight: bold;
				}
			}
		}

		//页头
		.page_header {
			padding: 0 20px;
			height: 60px;
			line-height: 60px;
			background-color: #d8e4f0;
			font-size: 24px;
			font-weight: bold;
			box-shadow: 0 2px 4px rgba(0, 0, 0, 0.075);
		}
	}
</style>
<style scoped>
	.main_box {
		height: calc(100vh - 60px);
		overflow-y: auto;
	}

	.main_box .main_main {
		position: relative;
		min-height: calc(100% - 0px);
		max-height: auto;
		background-color: #fafafa;
	}

	.el-header,
	.el-main {
		padding: 0;
	}

	.training-page {
		padding: 12px;
		min-height: 100vh;
		box-sizing: border-box;
	}

	.user-block {
		margin-bottom: 20px;
	}

	.label {
		font-size: 14px;
		color: #303133;
		font-weight: 600;
		margin-bottom: 10px;
	}

	.file-panel {
		background: #fff;
		border: 1px solid #dcdfe6;
		margin-top: 40px;
	}

	.panel-header {
		display: flex;
		justify-content: space-between;
		align-items: center;
		padding: 8px 10px 0;
	}

	.panel-title {
		font-size: 18px;
		font-weight: 700;
		color: #222;
		line-height: 32px;
	}

	.panel-actions {
		display: flex;
		align-items: center;
		gap: 10px;
	}

	.search-input {
		width: 220px;
	}

	.file-table {
		width: 100%;
		margin-top: 8px;
	}

	::v-deep .el-form-item__label {
		font-size: 16px;
		color: #222;
		font-weight: 700;
		padding-bottom: 8px;
		position: relative;
	}

	::v-deep .btn span {
		text-decoration: underline;
	}
</style>